import { Global } from "../service/global";
import {Component} from "../interface/component";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import Events from "../service/events";
import EVENTS from "../constants/events";

export class IntroBannerAnim implements Component {
    private $window: JQuery;
    private $root:JQuery;
    private $hotdog: JQuery;
    private $floatingPhoto: JQuery;
    private $toppingKetchup: JQuery;
    private $toppingChilli: JQuery;
    private $toppingMustard: JQuery;
    private $bg: JQuery;
    private scrollSegmentOne: JQuery;
    private scrollSegmentTwo: JQuery;
    private isMobile:boolean;
    public events: Events;

    private initialise:any;
    private animHotdog:any;
    private animKetchup:any;
    private animChillies:any;
    private animPhoto:any;
    private animMustard:any;

    constructor(elem: HTMLElement) {
        this.$window = $(<any>window);
        this.$root   = $(elem);
    }

    init() {
        // @ts-ignore
        gsap.registerPlugin(ScrollTrigger);
        
        this.$hotdog          = $('.c-brand-overview__image--offset-one .c-brand-image', this.$root);
        this.$floatingPhoto   = $('.c-brand-overview__image--offset-two .c-brand-image', this.$root);
        this.$bg              = $('.l-brand-background-media');
        this.$toppingKetchup  = $('.c-brand-overview__image--ingredient-one', this.$root);
        this.$toppingChilli   = $('.c-brand-overview__image--ingredient-two', this.$root);
        this.$toppingMustard  = $('.c-brand-overview__image--ingredient-three', this.$root);
        this.scrollSegmentOne = $('.c-brand-overview--segment-one', this.$root);
        this.scrollSegmentTwo = $('.c-brand-overview--segment-two', this.$root);

        this.events.addListener(EVENTS.VIEWPORT_START, this.handleViewportChange);
        this.events.addListener(EVENTS.VIEWPORT_CHANGE, this.handleViewportChange);
    }

    private initDesktop = () => {
      /* Reset */
      this.reset();

      //console.log('initDesktop');

      // @ts-ignore
      this.initialise = gsap.timeline({
        scrollTrigger: {
          trigger: this.$root,
          onEnter: this.dspDesktopBackground
        }, 
      });

      /* Parallax elements 
      */

      // @ts-ignore
      this.animHotdog = gsap.to(this.$hotdog, {
        //yPercent: this.getPosHotDog(),
        yPercent: 7,
        ease: 'sine.out',
        scrollTrigger: {
          trigger: this.scrollSegmentOne,
          start: 'clamp(top bottom)', 
          end: 'clamp(bottom top)',
          scrub: true
        }, 
      });

      // @ts-ignore
      this.animKetchup = gsap.to(this.$toppingKetchup, {
        yPercent: 50,
        //yPercent: this.getPosKetchup(),
        ease: 'sine.out',
        scrollTrigger: {
          trigger: this.scrollSegmentOne,
          start: 'clamp(top bottom)', 
          end: 'clamp(bottom top)',
          scrub: true
        }, 
      });

      // @ts-ignore
      this.animChillies = gsap.to(this.$toppingChilli, {
        yPercent: -40,
        //yPercent: this.getPosChilli(),
        ease: 'sine.out',
        scrollTrigger: {
          trigger: this.$root,
          start: 'clamp(top bottom)', 
          end: 'clamp(bottom top)',
          scrub: true
        }, 
      });

      // @ts-ignore
      this.animPhoto = gsap.to(this.$floatingPhoto, {
        yPercent: -10,
        //yPercent: this.getPosFloatingPhoto(),
        ease: 'sine.out',
        scrollTrigger: {
          trigger: this.scrollSegmentTwo,
          start: 'clamp(top bottom)',
          end: 'clamp(bottom top)',
          scrub: true
        }, 
      });

      // @ts-ignore
      this.animMustard = gsap.to(this.$toppingMustard, {
        yPercent: -60,
        //yPercent: this.getPosMustard(),
        ease: 'sine.out',
        scrollTrigger: {
          trigger: this.scrollSegmentTwo,
          start: 'clamp(top bottom)', 
          end: 'clamp(bottom top)',
          scrub: true
        }, 
      });
    }

    private initMobile() {
      /* Reset */
      this.reset();
      this.dspMobileBackground();
    }

    private dspDesktopBackground = () => {
        // @ts-ignore
        let tl = gsap.timeline();

        // @ts-ignore
        tl.fromTo(this.$bg, { opacity:0 }, {opacity: 1, duration: 0.8, ease: 'circ.out' })
        .fromTo(this.$bg, { scale: 1.1 }, { scale: 1, duration: 0.8, ease: 'sine.out' }, 0)
        .fromTo(this.$bg, { y: '+=90' }, { y: '0', duration: 0.8, ease: 'sine.out' }, 0)
        .fromTo(this.$hotdog, { opacity: 0 }, { opacity: 1, duration: 0.25, ease: 'sine.out' }, 0.7)
        .fromTo(this.$hotdog, { xPercent: 200 }, { xPercent: 0, duration: 1.1, ease: 'quad.inOut' }, 0.7)
        .fromTo(this.$hotdog, { rotation: 160 }, { rotation:0, duration: 1.2, ease: 'quad.out' }, 0.7)
        .fromTo(this.$toppingKetchup, { xPercent: -50, opacity: 0 }, { xPercent: 0, opacity: 1, duration: 0.7, ease: 'sine.out' }, 1)
        .fromTo(this.$toppingChilli, { x: '+=100', opacity: 0 }, { x: '0', opacity: 1, duration: 0.7, ease: 'sine.out' }, 1)
        .fromTo(this.$floatingPhoto, { y: '+=50', opacity: 0 }, { y: '0', opacity: 1, duration: 0.7, ease: 'quad.inOut' }, 1)
        .fromTo(this.$toppingMustard, { x: '+=100', opacity: 0 }, { x: '0', opacity: 1, duration: 0.5, ease: 'sine.out' }, 1);
    }

    private dspMobileBackground = () => {
        // @ts-ignore
        let tl = gsap.timeline();

        // @ts-ignore
        tl.fromTo(this.$hotdog, { opacity: 0 }, { opacity: 1, duration: 0.25, ease: 'sine.out' }, 0)
        .fromTo(this.$hotdog, { y: '+=40' }, { y: '0', duration: 0.4, ease: 'sine.out' }, 0);
    }

    private reset = () => {
      if (typeof this.animPhoto != 'undefined') { this.animPhoto.kill(); }
      if (typeof this.animHotdog != 'undefined') { this.animHotdog.kill(); }
      if (typeof this.animKetchup != 'undefined') { this.animKetchup.kill(); }
      if (typeof this.animChillies != 'undefined') { this.animChillies.kill(); }
      if (typeof this.animMustard != 'undefined') { this.animMustard.kill(); }
      if (typeof this.initialise != 'undefined') { this.initialise.kill(); }
    }

    private handleViewportChange = (size: string) => {
        switch (size) {
            case 'mobile':
            case 'xlargemobile':
                if (typeof this.isMobile === 'undefined' || !this.isMobile) { 
                  this.isMobile = true;
                  this.initMobile();
                  //console.log('mobile');
                }
                break;
            
            case 'smalldesktop':
            case 'desktop':
            case 'middesktop':
                if (typeof this.isMobile === 'undefined' || this.isMobile) { 
                  this.isMobile = false;
                  this.initDesktop();
                  //console.log('desktop and above');
                }
                break;
        }
    }

    public setEventHandler(events: Events) {
        this.events = events;
    }

    /* Responsive positioning for animation */

    /* private getPosHotDog = ():number => {
      let size = Global.getViewport().width;
      if (size < 1050) {
        return 24;
      } else if (size >= 1050 && size < 1150) {
        return 20;
      } else if (size >= 1150 && size < 1366) {
        return 15;
      } else if (size >= 1366) {
        return 17;
      }
    }

    private getPosMustard = ():number => {
      let size = Global.getViewport().width;
      if (size < 980) {
        return -60;
      } else if (size >= 980 && size < 1366) {
        return -90;
      } else if (size >= 1366) {
        return -60;
      }
    }

    private getPosKetchup = ():number => {
      let size = Global.getViewport().width;
      if (size < 980) {
        return 300;
      } else if (size >= 1200) {
        return 180;
      }
    }

    private getPosChilli = ():number => {
      let size = Global.getViewport().width;
      if (size < 980) {
        return -100;
      } else if (size >= 980 && size < 1200) {
        return -160;
      } else if (size >= 1200 && size < 1366) {
        return -70;
      } else if (size >= 1366) {
        return -160;
      }
    }

    private getPosFloatingPhoto = ():number => {
      let size = Global.getViewport().width;
      if (size < 786) {
        return 75;
      } else if (size >= 786 && size < 825) {
        return 50;
      } else if (size >= 826 && size < 980) {
        return 30;
      } else if (size >= 980 && size < 1024) {
        return 20;
      } else if (size >= 1024 && size < 1100) {
        return 18;
      } else if (size >= 1100 && size < 1200) {
        return 15;
      } else if (size >= 1200 && size < 1300) {
        return 24;
      } else if (size >= 1300 && size < 1366) {
        return 30;
      } else if (size >= 1366) {
        return 40;
      }
    } */
}
